import { useAtom } from 'jotai'
import { useCallback } from 'react'
import {
  saveSettings,
  type UserSettings,
  userSettingsAtom,
} from '../stores/user-settings/atoms'

export function useUserSettings() {
  const [userSettings, setSettings] = useAtom(userSettingsAtom)

  const updateSettings = useCallback(
    (newSettings: Partial<UserSettings>) => {
      setSettings((prevSettings) => {
        const updatedSettings = {
          ...prevSettings,
          ...newSettings,
        }
        saveSettings(updatedSettings)
        return updatedSettings
      })
    },
    [setSettings],
  )

  const onSmallestBalanceInput = useCallback(
    (input: string) => {
      const value = input === '' ? 0 : Number.parseFloat(input)
      const isNumber = !Number.isNaN(value) && value >= 0 && value <= 99999
      if (!isNumber) return null

      // Strip letters from input but not point
      const cleanedInput = input.replace(/[^0-9.]/g, '')

      updateSettings({
        smallestBalanceUsd: value,
      })

      return cleanedInput
    },
    [updateSettings],
  )

  return {
    userSettings,
    updateSettings,
    onSmallestBalanceInput,
  }
}
